
import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { convertFormToSupabaseFormat } from '@/utils/supabase-utils';

interface ArchiveFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  formId: string;
  formName: string;
  isArchived: boolean;
  onArchiveChange: () => void;
}

const ArchiveFormDialog: React.FC<ArchiveFormDialogProps> = ({
  open,
  onOpenChange,
  formId,
  formName,
  isArchived,
  onArchiveChange
}) => {
  const action = isArchived ? 'unarchive' : 'archive';
  
  const handleConfirmAction = async () => {
    try {
      console.log(`Attempting to ${action} form ${formId}`);
      console.log('Current archive status:', isArchived);
      
      // Update using a partial form object that will be converted properly by convertFormToSupabaseFormat
      const formUpdate = {
        id: formId,
        isArchived: !isArchived
      };
      
      const { error } = await supabase
        .from('forms')
        .update(convertFormToSupabaseFormat(formUpdate))
        .eq('id', formId);
        
      if (error) {
        console.error(`Error ${action}ing form:`, error);
        throw error;
      }
      
      console.log(`Form ${action}d successfully`);
      toast.success(`Form ${action}d successfully`);
      
      // Close the dialog
      onOpenChange(false);
      
      // Call the callback to refresh the forms list
      onArchiveChange();
    } catch (error) {
      console.error(`Error ${action}ing form:`, error);
      toast.error(`Failed to ${action} form`);
    }
  };
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{isArchived ? 'Unarchive' : 'Archive'} Form: {formName}</AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground">
            {isArchived ? (
              "This will restore the form and make it visible in your main form list again."
            ) : (
              "This will hide the form from your main form list, but you can restore it later. Form data will be preserved."
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirmAction}>
            {isArchived ? 'Unarchive' : 'Archive'} Form
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ArchiveFormDialog;
